import { Box, Flex, Spinner } from "@chakra-ui/react";
export default function SpinnerApp({ show, children }) {
  return (
    <Box position={"relative"} w={"100vw"} h={"100vh"}>
      <Flex
        display={show ? "flex" : "none"}
        w={"100vw"}
        position={"absolute"}
        top={"0"}
        left={"0"}
        h={"100vh"}
        justifyContent={"center"}
        alignItems={"center"}
        bg={"rgb(0,0,0, 40%)"}
        zIndex={"100"}
      >
        <Spinner size={"xl"} />
      </Flex>
      {children}
    </Box>
  );
}
